module.exports = __webpack_public_path__ + "media/images/products/longlife/icon-img-inheritance-bbc1b42ce2ee345a2743dcaca4c1af86.svg";